import IconTooltipButton from '../../../../../button/IconTooltipButton'
import FormatDateRange from '../../../../../date/FormatDateRange'
import DataGrid from '../../../../../table/DataGrid'

const TermsList = ({ list = [], isLoading, permissions, onModal }) => {
  const columnsTable = [
    {
      show: true,
      key: 'name',
      align: 'center',
      hide: false,
      width: 5,
      label: 'Name'
    },
    {
      show: true,
      key: 'primary',
      align: 'left',
      hide: false,
      width: 200,
      label: 'Period'
    },
    {
      show: permissions['preview'] || permissions['updated'] || permissions['deleted'],
      key: 'actions',
      align: 'center',
      hide: false,
      width: 50,
      label: 'actions'
    }
  ];

  return (
    <DataGrid
      id='terms-list'
      showSetting={false}
      rowsPerPage={list?.length || 10}
      groupBy={'year'}
      orderGroupBy={'desc'}
      rows={list.map((row) => {
        return {
          ...row,
          primary: (
            <FormatDateRange startDate={row.startDate} endDate={row.endDate} />
          ),

          actions: (
            <div>
              {permissions['preview'] && (
                <IconTooltipButton
                  title='Preview'
                  icon='expand-alt'
                  onClick={() => onModal('preview', row)}
                />
              )}
              {permissions['updated'] && (
                <IconTooltipButton
                  title='Edit'
                  icon={['fas', 'edit']}
                  onClick={() => onModal('edit', row)}
                />
              )}
              {permissions['deleted'] && (
                <IconTooltipButton
                  title='Delete'
                  icon={['fas', 'trash-alt']}
                  onClick={() => onModal('delete', row)}
                />
              )}
            </div>
          )

        };
      })}
      loading={isLoading}
      columns={columnsTable}
      labelNoRows="You don't have any term yet"
    />
  );
}

export default TermsList